export function join(arr, separator) {
  return arr.join(separator);
}
